/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const DeleteMessages = gql`
  mutation DeleteMessages($ids: [ID!]!) {
    deleteMessages(ids: $ids)
  }
`;
